module.exports = "data:image/gif;base64,R0lGODlhCgAKAJEAAAAAAP///zd73P///yH5BAEAAAMALAAAAAAKAAoAAAIUnI8jgmvLlHtwnpqkpZh72UTZUQAAOw=="